angular.module('bmsApp.trugreen.job')
	.controller('TGJobViewCtrl',
		function ($state,
				  $scope,
				  $filter,
				  TGJobSvc,
				  EmailSvc,
				  TGInvoiceSvc,
				  NoteSvc,
				  notify,
				  $window,
				  $ngBootbox,
				  TGVisitSvc) {

			function init() {
				TGJobSvc.read(self.jobId, {page_name: 'view'})
					.then(function (response) {
						self.job = response.data.tg_job;
						self.loading = false;
						if(self.covertedJustNow === 'true'){
							$ngBootbox.confirm('Would you like to send treatment plan email?')
								.then(function () {
									$ngBootbox.hideAll();
									setTimeout(function(){
										self.methods.treatmentPlanEmailForm(self.job);
									},2000);

								});
						}
					});
			}

			function preinvoiceVisit(visit) {
				$ngBootbox.confirm('Are you sure you want to do this? This action is not undoable.')
					.then(function () {
						var modalResult = {};
						self.preinvoicing = true;
						return TGInvoiceSvc.preInvoice(visit.id).then(function (response) {
							self.preinvoicing = false;
								angular.extend(visit,
									response.data.visit
								);
							});
					});
			}

			function addVisit() {
				TGVisitSvc.showAddVisitModal()
					.then(function (response) {
						var params = {
							technician_id: response.assignedEmployeeId,
							visit_date: response.dateChosen,
							job_and_quote_id: self.job.id
						};

						TGVisitSvc.save(params)
							.then(function () {
								init();
							});
					});
			}

			function copyQuote() {
				TGJobSvc.showCopyQuoteModal(self.job).then(function(result) {
					notify({
						message: 'Successfully copied'
					});
					$state.go('main.trugreen.quote.index.view', {quoteId: result.id});
				});
			}

			function addNote() {
				var note = {
					object_type: 'App\\Models\\Trugreen\\Job',
					object_id: self.jobId
				};
				NoteSvc.showSaveModal(note);
			}

			function emailForm(emailAddress, objectType, objectId) {
				var email = {
					to: emailAddress,
					object_type: objectType,
					object_id: objectId
				};
				EmailSvc.showSendModal(email, $scope.customer);
			}


			function treatmentPlanEmailForm(job) {
				var emailAddress = '';
				var keepGoing = true;
				angular.forEach(job.customer.primary_contact.contact_details, function(contactDetail){
					if(keepGoing) {
						if (contactDetail.contact_detail_type.group == 'email') {
							emailAddress = contactDetail.value;
							keepGoing = false;
						}
					}
				});
				var email = {
					to: emailAddress,
					object_type: 'App\\Models\\Trugreen\\Job',
					object_id: job.id
				};

				TGJobSvc.showTreatmentPlanEmailFormModal(email, job);
			}

			function viewChemicalForm(filled) {
				if (filled) {
					$window.open('trugreen/chemical-form/'+self.jobId);
				}
				else {
					$window.open('trugreen/chemical-form');
				}
			}


			function cancelJob() {
				TGJobSvc.showCancelJobModal(self.job).then(function(result) {
					angular.extend(self.job, result);
				});
			}

			function uncancelJob() {
				TGJobSvc.uncancelJob(self.job).then(function(response) {
					angular.extend(self.job, response.data.tg_job);
				});
			}

			function showCustomerNotes() {
				self.notes.activeObjectType = 'App\\Models\\Crm\\Customer';
				self.notes.activeObjectId = self.job.customer.id;
			}

			function showJobNotes() {
				self.notes.activeObjectType = 'App\\Models\\Trugreen\\Job';
				self.notes.activeObjectId = self.job.id;
			}

			function showJobComplaints() {
				self.complaints.activeObjectType = 'App\\Models\\Trugreen\\Job';
				self.complaints.activeObjectId = self.job.id;
			}

			var self = $scope.TGJobViewCtrl = {
				loading: true,
				methods: {
					init: init,
					preinvoiceVisit: preinvoiceVisit,
					addVisit: addVisit,
					emailForm: emailForm,
					addNote: addNote,
					copyQuote: copyQuote,
					viewChemicalForm: viewChemicalForm,
					cancelJob: cancelJob,
					uncancelJob: uncancelJob,
					showCustomerNotes: showCustomerNotes,
					showJobNotes: showJobNotes,
					showJobComplaints:showJobComplaints,
					treatmentPlanEmailForm: treatmentPlanEmailForm,
				},
				jobId: parseInt($state.params.jobId),
				covertedJustNow: $state.params.justNowConverted,
				notes: {
					view: 'job',
					api: {}
				},
				complaints: {
					api: {},
				},

			};

		});
